import { firebase } from "@firebase/app";
import "@firebase/firestore";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAouHUGJBtgkQL055WGvCVez2r6bCFAixc",
  authDomain: "ticketing-dessel.firebaseapp.com",
  databaseURL: "https://ticketing-dessel.firebaseio.com",
  projectId: "ticketing-dessel",
  storageBucket: "ticketing-dessel.appspot.com",
  messagingSenderId: "662977942150"
});

export const db = firebaseApp.firestore();
